import { ReactTFC } from "../fp/missing-ts-parts";
import React, { useEffect, useState } from "react";

export const Suspended: ReactTFC<{
  children: React.ReactNode;
  Fallback: React.ReactNode;
  suspensionKey: string;
  timeoutMs: number;
}> = props => {
  const [shouldBeShown, setShouldBeShown] = useState(false);

  useEffect(() => {
    setShouldBeShown(false);
    const id = setTimeout(() => setShouldBeShown(true), props.timeoutMs);

    return () => {
      clearTimeout(id);
    };
  }, [props.suspensionKey]);

  return shouldBeShown ? <>{props.children}</> : <>{props.Fallback}</>;
};
